import moment from "moment";

/** Mês corrente: o padrão de todos os relatórios (e do kyojin sem from/to). */
export function currentMonth() {
  return [moment().startOf("month"), moment().endOf("month")];
}

/** Dia escolhido, sem fuso: o kyojin só lê YYYY-MM-DD. */
export function periodParams(period) {
  return {
    from: period && period[0] ? period[0].format("YYYY-MM-DD") : undefined,
    to: period && period[1] ? period[1].format("YYYY-MM-DD") : undefined,
  };
}
